import "./style.css";
import * as React from 'react';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import CallIcon from '@mui/icons-material/Call';
import AddIcCallIcon from '@mui/icons-material/AddIcCall';
import GavelIcon from '@mui/icons-material/Gavel';

export default function AccountMenu({ judul, isi }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const nowstate = useSelector((state) => state);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logout = () => {
    Cookies.set("user", "");
    dispatch({
      type: "LOGOUT",
    });
    navigate("/login");
  };

  const listMail = () => {
    navigate("/NewMail");
  };

  const newcall = () => {
    navigate("/NewCall");
  };

  const goLegalTodo = () => {
    window.location.href = "/#/legaltodolist";
  };

  const showLegalIcon =
    nowstate?.user?.legal === "yes" || nowstate?.user?.legal === true;

  return (
    <Grid container sx={{ justifyContent: "right", mr: "5", pt: 2 }}>
      <Grid container sx={{ alignItems: 'center', justifyContent: "space-between", pr: "5" }}>
        <Grid
          item
          sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            pl: 3,
            flexDirection: 'column'
          }}
        >
          <Typography variant="h4" gutterBottom fontWeight="bold">
            {judul ?? ""}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight="bold"
            sx={{ mt: -2, opacity: 0.5 }}
          >
            {isi ?? ""}
          </Typography>
        </Grid>

        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Telepon Masuk">
            <IconButton
              onClick={newcall}
              sx={{ mr: 1, size: "large" }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <CallIcon color="disabled" sx={{ width: 50, height: 50 }} />
            </IconButton>
          </Tooltip>
        </Grid>

        {showLegalIcon && (
          <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Legal To Do List">
              <IconButton
                onClick={goLegalTodo}
                sx={{ mr: 1, size: "large" }}
              >
                <GavelIcon sx={{ width: 50, height: 50 }} />
              </IconButton>
            </Tooltip>
          </Grid>
        )}

        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title="Dedicated Call">
            <IconButton
              onClick={() => navigate("/dedicatedcall")}
              sx={{ mr: 1, size: "large" }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <AddIcCallIcon sx={{ width: 50, height: 50 }} />
            </IconButton>
          </Tooltip>
        </Grid>

        <Grid item sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          <Tooltip title="Surat Masuk">
            <IconButton
              onClick={listMail}
              sx={{ mr: 1, size: "large" }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <MoveToInboxIcon sx={{ width: 50, height: 50 }} />
            </IconButton>
          </Tooltip>
        </Grid>

        <Grid item sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              sx={{ mr: 5, size: "large" }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              <Avatar sx={{ width: 50, height: 50 }} />
            </IconButton>
          </Tooltip>
        </Grid>

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem>
            <Avatar /> My account
          </MenuItem>
          <Divider />
          <MenuItem>
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            Settings
          </MenuItem>
          <MenuItem onClick={() => { logout(); }}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Grid>
    </Grid>
  );
}